import React, { Component } from 'react';
import { Layout } from 'antd';

import StrikeFooter from '../../components/StrikeFooter';

import 'antd/dist/antd.css';
import '../../App.scss';

const { Header, Content, Footer } = Layout;

export default class AnonLayout extends Component {
  render() {
    return (
      <Layout className="anon-layout" style={{ background: 'white' }}>
        <Content style={{ padding: 0, margin: 0, width: '100%' }}>
          <div className="site-layout-content" style={{ width: '100%', margin: 0, padding: 0 }}>
            {this.props.children}
          </div>
        </Content>
        <StrikeFooter locStrings={this.props.locStrings} />
      </Layout>
    );
  }
}
